import React, { useState, useEffect, useRef } from 'react'
import { Modal } from 'react-bootstrap';
import LoadingAlert from '../../components/Alerts/LoadingAlert';
import ErrorAlert from '../../components/Alerts/ErrorAlert';
import { RenderIf } from '../../components/utils/RenderIf';
import { Button } from 'react-bootstrap'
import { Card } from 'react-bootstrap';
import { DivicesFechtAPI } from '../../api/Divices';
import { MachinesFetchAPI } from '../../api/Machines';
import VendingModalKeyCode from './VendingModalKeyCode';
import VendingModalSupport from './VendingModalSupport';
import VendingModalVoucher from './VendingModalVoucher';
import img_dispensed from './img/delivery.gif'
import QRCode from "react-qr-code";
import img_Error from './img/error.gif'
import img_support from './img/support.gif'
import img_check from './img/check.gif'
import { VendingSnakkyFetchAPI } from '../../api/LocalRequest/VendingSnakky';
import oledComunication from './OledComunication';

import { useWindowSize } from '../../hooks/useWindowSize';
//* Gifs
import gif_1 from "./img/gif/gif-1.gif"
import gif_2 from "./img/gif/gif-2.gif"
import Swal from 'sweetalert2';
//Utils 
import { buildCloudinaryImageUrl } from '../../utils/CloudinaryImageUrl';

function VendingDispensed({ itemReadyDispense, showModalDispense, setShowModalDispense, ready, statusError, setStatusError, voucher_Order, dataInfoPaymentSelect, setEventHandlerMenu, order_code_register, clearShoppingCart, voidCreditDebit, dataNoteCredit, setDataRutaQr, dataRutaQr, shoppingCart, registerOrderTempReturn, inputRefLogDispensed, oledSupport, setAtivityTimer }) {
  let token = localStorage.getItem('x-access-token');
  let machine = JSON.parse(localStorage.getItem('machine_vending'));

  const inputRefSupport = useRef(null);
  const [contentSupport, setContentSupport] = useState({ title: "", body: [{ text: "" }, { text: "" }] })
  const [showModalvoucher, setshowModalvoucher] = useState(false);
  const [showModalSupport, setShowModalSupport] = useState(false);
  let routeQr = ""
  let branchoffice = ""



  if (localStorage.getItem('branchoffice_vending')) {
    if (localStorage.getItem('branchoffice_vending') != null || localStorage.getItem('branchoffice_vending') != '') {
      branchoffice = JSON.parse(localStorage.getItem('branchoffice_vending'))
      //routeQr = "192.168.1.12:3000/order/" + order_code_register + "/branchoffice/" + branchoffice.id
      routeQr = "https://smartpay.ai/order/" + order_code_register + "/branchoffice/" + branchoffice.id

    }
  }



  const viewItemreadyDispense = () => {
    const listDispense = itemReadyDispense.map((item) => (
      <>
        <div className={item.status == "success"
          ? 'rounded-4 border border-success border-3 p-3 m-3 bg-success-subtle'
          : 'rounded-4 border border-warning border-3 p-3 m-3 bg-success-subtle'}>

          <div className='d-flex  justify-content-between '>
            <img loading='lazy' src={buildCloudinaryImageUrl({url: item.img, width: 100, type: "image", quality: "auto"})} className='border rounded-4' height="100px" width="100px"></img>
            <div className='m-3'>
              <h2 className='text-center'>

                {item.name}
              </h2>
              <h3 className='text-center'>${item.price}</h3>
            </div>
            {item.status == "success"
              ? <><i className="uil uil-check-circle icon-button-params" ></i></>
              : <><i className="uil uil-exclamation-triangle icon-button-params"></i></>}
          </div>
        </div>
      </>
    ));
    return listDispense;
  }


  const handlerSuppor = async () => {
    setAtivityTimer(5)
    registerOrderTempReturn({ EMVStreamResponse: "0" })
    machine = JSON.parse(localStorage.getItem('machine_vending'))
    try {
      const response_machine = await MachinesFetchAPI.getmachineByid(machine.id, token)
      console.log(response_machine);
      setContentSupport({ title: "Error de despacho", body: [{ "text": response_machine.data.data.machine_name + " no se despacho correctamente el producto en la posicion: " + "X:" + shoppingCart[0].X + ", Y:" + shoppingCart[0].Y + " de la orden: " + order_code_register }, { text: "informacion:" }] })
      setShowModalSupport(true)
      //clearShoppingCart();
      setShowModalDispense(false);

    } catch (err) {
      console.log(err);
    }
  }

  const handlerChangeInputAction = () => {

    if (dataInfoPaymentSelect != "Yappy" && dataInfoPaymentSelect != "Clave" && dataInfoPaymentSelect != "Credito") {
      oledReturn()
      voidCreditDebit()
    } else {

      oledInputPhone()
      clearStatussentorandlimitDigit(8, "2,1,2,15,30,")
      handlerSuppor()


    }
  }

  const oledInputPhone = () => {
    if (machine.machine_subtype_code === "VGG") {
      oledComunication(0, '2,0')
      setTimeout(() => {
        oledComunication(0, "2,1,1,10,10,Ingresa tu numero")
      }, 50);

      oledComunication(0, '2,0')
      setTimeout(() => {
        oledComunication(0, "2,1,1,30,20,de celular")
      }, 100);
    }
  }

  const oledReturn = () => {
    if (machine.machine_subtype_code === "VGG") {
      oledComunication(0, '2,0')
      setTimeout(() => {
        oledComunication(0, '2,1,1,25,20,Devolucion')
      }, 50);

      setTimeout(() => {
        oledComunication(0, '2,1,1,35,30,0.En proceso.')
      }, 100);
    }
  }

  const clearStatussentorandlimitDigit = async (data, settingtxt) => {
    try {

      await VendingSnakkyFetchAPI.clearData({ "limit": data, "setting": settingtxt })

    } catch (err) {
      console.log(err);
    }
  }


  useEffect(() => {
    if (showModalDispense == true) {

      setTimeout(() => {
        inputRefLogDispensed.current.focus()
      }, 1000);

    }
  }, [showModalDispense])


  const { width } = useWindowSize();
  const qrSize = width <= 480 ? "200" : "300";

  return (
    <>

      {/*Modal dispense item showModalDispense*/}
      <Modal
        show={showModalDispense}
        fullscreen
        onHide={() => setShowModalDispense(false)}
        aria-labelledby="example-custom-modal-styling-title">
        <Modal.Body className='p-0 m-0' >
          <div
            className="vmd-root"
            onClick={() => (inputRefLogDispensed.current.focus(), setAtivityTimer(5))}
          >

            {/* ============================================================
       ESTADO 1: ready == true → Gracias por comprar
       ============================================================ */}
            <RenderIf isTrue={ready == true}>
              <section className="vmd-thanks">
                {/* Halo de fondo verde celebrando */}
                <div className="vmd-halo vmd-halo-ok" />

                <div className="vmd-thanks-content">
                  <div className="vmd-thanks-icon">
                    <i className="uil uil-heart-sign"></i>
                  </div>

                  <h1 className="vmd-thanks-title">
                    ¡Gracias por comprar,
                    <br />
                    <span >vuelve pronto!</span>
                  </h1>

                  <div className="vmd-gif-frame">
                    <img src={gif_1} className="vmd-gif" alt="Gracias" />
                  </div>
                </div>

                <footer className="vmd-powered">
                  <small>Powered by</small>
                  <h3>Smart Retail Group</h3>
                </footer>
              </section>
            </RenderIf>


            {/* ============================================================
       ESTADO 2: statusError != true → Despachando / Despachado
       ============================================================ */}
            <RenderIf isTrue={statusError != true}>
              <section className="vmd-dispensing">
                {/* Halo azul activo */}
                <div className="vmd-halo vmd-halo-load" />

                {/* Despachando en proceso */}

                {itemReadyDispense.length == 0 ? (
                  <>

                    <div className="vmd-dispensing-content">
                      <div className="vmd-dispensing-badge">
                        <span className="vmd-dispensing-dot" />
                        <span>En proceso</span>
                      </div>

                      <h2 className="vmd-dispensing-title">
                        Despachando
                        <br />
                        <span >productos</span>
                      </h2>

                      <div className="vmd-dispensing-img-frame">
                        <div className="vmd-dispensing-ring" />
                        <div className="vmd-dispensing-ring vmd-dispensing-ring-2" />
                        <div className='d-flex'>

                          <i class="fa-solid fa-hand-holding vmo-icon text-primary"></i>
                          <br />
                          <i class="uil uil-box vmo-icon text-primary"></i>

                        </div>

                      </div>

                      <p className="vmd-dispensing-hint">
                        Espera un momento mientras preparamos tu pedido
                      </p>
                    </div>

                    <footer className="vmd-powered">
                      <small>Powered by</small>
                      <h3>Smart Retail Group</h3>
                    </footer>
                  </>
                ) : (
                  <>
                    {/* Productos despachados correctamente */}
                    <div className="vmd-dispensed-content">
                      <div className="vmd-check-icon">
                        <svg className="vmd-check-svg" viewBox="0 0 80 80">
                          <circle className="vmd-check-circle" cx="40" cy="40" r="36" />
                          <path className="vmd-check-path" d="M 22 42 L 35 55 L 58 28" />
                        </svg>
                      </div>

                      <h2 className="vmd-dispensed-title">
                        Productos despachados
                        <br />
                        <span >correctamente</span>
                      </h2>

                      <div className="vmd-dispensed-list">
                        {viewItemreadyDispense()}
                      </div>
                    </div>

                    <footer className="vmd-powered">
                      <small>Powered by</small>
                      <h3>Smart Retail Group</h3>
                    </footer>
                  </>
                )}
              </section>
            </RenderIf>


            {/* ============================================================
       ESTADO 3: statusError == true → Error / Devolución
       ============================================================ */}
            <RenderIf isTrue={statusError == true}>
              <section className="vmd-error-wrap">

                {/* Halo dinámico según sub-estado */}
                <RenderIf isTrue={dataNoteCredit == true}>
                  <div className="vmd-halo vmd-halo-ok" />
                </RenderIf>
                <RenderIf isTrue={dataNoteCredit == false}>
                  <div className="vmd-halo vmd-halo-err" />
                </RenderIf>

                {/* Cabecera de devolución (solo si dataNoteCredit == true) */}
                <RenderIf isTrue={dataNoteCredit == true}>
                  <div className="vmd-error-header">
                    <span className="vmd-error-eyebrow">Detalle de la devolución</span>
                  </div>
                </RenderIf>

                <div className="vmd-error-body">

                  {/* ===== 3a: devolución exitosa ===== */}
                  <RenderIf isTrue={dataNoteCredit == true}>
                    <div className="vmd-error-icon-wrap">
                      <img src={img_check} className="vmd-error-check-img" alt="Devolución exitosa" />
                    </div>

                    <h1 className="vmd-error-title vmd-error-title-ok">
                      Se realizó la
                      <br />
                      <span >devolución correctamente</span>
                    </h1>

                    <div className="vmd-qr-card">
                      <div className="vmd-qr-label">
                        <i className="uil uil-qrcode-scan"></i>
                        <span>Comprobante digital</span>
                      </div>
                      <div className="vmd-qr-wrap">
                        <QRCode
                          value={routeQr}
                          size={qrSize}
                          bgColor="#282c34"
                          fgColor="#fff"
                          level="H"
                        />
                      </div>
                      <p className="vmd-qr-hint">
                        Escanea el QR o toma una foto para conservar tu comprobante
                      </p>
                    </div>
                  </RenderIf>

                  {/* ===== 3b: error en despacho ===== */}
                  <RenderIf isTrue={dataNoteCredit == false}>
                    <div className="vmd-error-icon-wrap">
                      <img src={gif_2} className="vmd-error-gif" alt="Error" />
                    </div>

                    <h1 className="vmd-error-title vmd-error-title-err">
                      Ocurrió un error
                      <br />
                      <span >en el despacho</span>
                    </h1>

                    <div className="vmd-error-message-card">
                      <i className="uil uil-exclamation-circle"></i>
                      <p>Se realizará la devolución del monto pagado</p>
                    </div>

                    {/* El QR y método también aparecen en error */}
                    <div className="vmd-qr-card vmd-qr-card-err">
                      <div className="vmd-qr-wrap">
                        <QRCode
                          value={routeQr}
                          size={qrSize}
                          bgColor="#282c34"
                          fgColor="#fff"
                          level="H"
                        />
                      </div>
                    </div>
                  </RenderIf>

                  {/* Voucher (compartido) */}
                  <RenderIf isTrue={voucher_Order != "0"}>
                    <div className="vmd-voucher-section">
                      <div className="vmd-voucher-divider" />
                      <div className="vmd-voucher-info">
                        <div className="vmd-voucher-row">
                          <span className="vmd-voucher-label">Método de pago</span>
                          <span className="vmd-voucher-value">{dataInfoPaymentSelect}</span>
                        </div>
                        <div className="vmd-voucher-row">
                          <span className="vmd-voucher-label">Recibo de pago</span>
                        </div>
                        <VendingModalVoucher
                          showModalvoucher={showModalvoucher}
                          setshowModalvoucher={setshowModalvoucher}
                          voucher_Order={voucher_Order}
                        />
                      </div>
                    </div>
                  </RenderIf>
                </div>

                {/* Footer con acción según sub-estado */}
                <footer className="vmd-error-footer">
                  <RenderIf isTrue={dataNoteCredit == false}>
                    <button
                      className="vmd-btn vmd-btn-primary"
                      onClick={async () => { dataInfoPaymentSelect != "Yappy" && dataInfoPaymentSelect != "Clave" && dataInfoPaymentSelect != "Credito" ? voidCreditDebit() : handlerSuppor() }}
                    >
                      <i className="uil uil-redo"></i>
                      <span>Continuar para solicitar devolución</span>
                    </button>
                  </RenderIf>

                  <RenderIf isTrue={dataNoteCredit == true}>
                    <button
                      className="vmd-btn vmd-btn-close"
                      onClick={async () => (clearShoppingCart(true))}
                    >
                      <i className="uil uil-times-circle"></i>
                      <span>Cerrar</span>
                    </button>
                  </RenderIf>
                </footer>
              </section>
            </RenderIf>

            {/* Input oculto (escáner) — preservado */}
            <input
              id="inputDispence"
              className="vmd-hidden-input"
              ref={inputRefLogDispensed}
              inputMode="none"
              type="text"
              onChange={() => handlerChangeInputAction()}
              autoFocus
            />
          </div>
        </Modal.Body>
      </Modal >





      <VendingModalSupport showModalSupport={showModalSupport} setShowModalSupport={setShowModalSupport} contentSupport={contentSupport} setEventHandlerMenu={setEventHandlerMenu} suportReturn={true} inputRefSupport={inputRefSupport} setAtivityTimer={setAtivityTimer} ></VendingModalSupport>

    </>
  )
}

export default VendingDispensed